import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-confarence-room-link',
  templateUrl: './confarence-room-link.component.html',
  styleUrls: ['./confarence-room-link.component.scss']
})
export class ConfarenceRoomLinkComponent {

    constructor(  @Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<ConfarenceRoomLinkComponent>,private clipboard: Clipboard,public matSnackBar: MatSnackBar,) {}


  ngOnInit() {
    console.log("data_room",this.data);
  }


  public copyClipBordFuntion(val:any){
    if(val === "logedUser"){
  //   // this.clipboard.copy(`${this.data.url}/conference-room/${this.data.room_key}/${this.data.log_in_Id._id}?host=1`)
    this.clipboard.copy(`${this.data.url}/conference-room/${this.data.room_key}/${this.data.log_in_Id._id}?host=1`)

    }else if(val === "participent"){
    this.clipboard.copy(`${this.data.url}/conference-room/${this.data.room_key}/64f985d7443cd7f56bb85a95?host=${this.data.log_in_Id._id}`)
    }

    this.matSnackBar.open('Copied to Clipboard', 'Ok', {
      duration: 3000,
    });
  }


  public sessonStater(){
    window.open(`${this.data.url}/conference-room/${this.data.room_key}/64c755c75cf3682b3154586f?host=1`)
  }



}
